// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }
    
    window.addEventListener('resize', setFullHeight);
    setFullHeight();    

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }

            if ($(window).scrollTop() > 5) {
                $('.header').addClass('fixed');
            } else {
                $('.header').removeClass('fixed');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });

        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        // AOS.init({ disable: 'mobile' });

        if ($('.slider').length) {
            $('.slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 1000,
                infinite: true,
                dots: true,
                arrows: false,
                adaptiveHeight: true
            });
        }

        if ($('.hcTabs__album').length) {
            $('.hcTabs__album').slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,
                lazyLoad: "progressive",
                speed: 800,
                arrows: false,
                dots: false,
                draggable: false,
                pauseOnFocus: false,
                pauseOnHover: false
            });

            $('.hcTabs__control .nav-link').on('shown.bs.tab', function (e) {
                const idTarget = e.target.getAttribute('data-bs-target');
                setTimeout(() => {
                    $(idTarget).find('.hcTabs__album').slick('refresh');
                }, 100);
            });
        }
        
        if ($('.expVideos__slider').length) {
            $('.expVideos__slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true,
                lazyLoad: "progressive",
                speed: 800,
                arrows: false,
                dots: true,
                draggable: false,
                pauseOnFocus: false,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        if ($('.homeClient__slider').length) {
            $('.homeClient__slider').slick({
                slidesToShow: 7,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 1,
                speed: 1600,
                cssEase: 'linear',
                infinite: true,
                dots: false,
                arrows: false,
                centerMode: true,
                // variableWidth: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 7,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        }

        if ($('.expGallery__album').length) {
            
            function initMasonry() {
                $('.expGallery__album').masonry({
                    // options
                    itemSelector: '.item',
                    columnWidth: '.item',
                    percentPosition: true
                });
            }

            initMasonry();

            
            $('.expGallery__tab .nav-link').on('shown.bs.tab', function (e) {
                const idTarget = e.target.getAttribute('data-bs-target');
                setTimeout(() => {
                    initMasonry();
                }, 100);
            });
        }

        if ($('.postGallery__album').length) {
            $('.postGallery__album').masonry({
                // options
                itemSelector: '.item',
                columnWidth: '.item',
                percentPosition: true
            });
        }
        

        if ($('.feedback__slider').length) {
            $('.feedback__slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                infinite: true,
                lazyLoad: "progressive",
                speed: 800,
                arrows: false,
                dots: true,
                draggable: false,
            });
        }
    });


    const video = document.getElementById("expVideo");
    const muteButton = document.getElementById("muteToggle");

    if(muteButton) {
        muteButton.addEventListener("click", function () {
            if (video.muted) {
                video.muted = false;
                muteButton.textContent = "🔇 Tắt tiếng";
            } else {
                video.muted = true;
                muteButton.textContent = "🔊 Bật tiếng";
            }
        });
    }

})(jQuery)